/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Start_NowInputs */

const en_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Now`)
};

const ar_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ الآن`)
};

const de_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt beginnen`)
};

const es_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar ahora`)
};

const fr_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer maintenant`)
};

const it_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia ora`)
};

const ja_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ始める`)
};

const ko_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 시작하기`)
};

const pt_br_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar agora`)
};

const ru_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать`)
};

const th_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มต้นตอนนี้`)
};

const tr_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Başla`)
};

const zh_cn_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`马上开始`)
};

const zh_tw_btn_start_now = /** @type {(inputs: Btn_Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`馬上開始`)
};

/**
* | output |
* | --- |
* | "Start Now" |
*
* @param {Btn_Start_NowInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_start_now = /** @type {((inputs?: Btn_Start_NowInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Start_NowInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_start_now(inputs)
	if (locale === "ar") return ar_btn_start_now(inputs)
	if (locale === "de") return de_btn_start_now(inputs)
	if (locale === "es") return es_btn_start_now(inputs)
	if (locale === "fr") return fr_btn_start_now(inputs)
	if (locale === "it") return it_btn_start_now(inputs)
	if (locale === "ja") return ja_btn_start_now(inputs)
	if (locale === "ko") return ko_btn_start_now(inputs)
	if (locale === "pt_br") return pt_br_btn_start_now(inputs)
	if (locale === "ru") return ru_btn_start_now(inputs)
	if (locale === "th") return th_btn_start_now(inputs)
	if (locale === "tr") return tr_btn_start_now(inputs)
	if (locale === "zh_cn") return zh_cn_btn_start_now(inputs)
	return zh_tw_btn_start_now(inputs)
});